// extracted by mini-css-extract-plugin
module.exports = {"cancelCard":"CancelBookingStyle_cancelCard__1Jh8A"};